<template>
  <div>
    <b-navbar toggleable="md" type="dark" variant="dark">
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

      <b-navbar-brand to="/">Accueil</b-navbar-brand>

      <b-collapse id="nav_collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item to="/saisie">Saisies</b-nav-item>
          <b-nav-item to="/projet">Projets</b-nav-item>
          <b-nav-item to="/adherent">Adhérents</b-nav-item>
          <b-nav-item to="/referentiels">Référentiels</b-nav-item>
          <b-nav-item to="/recus-fiscaux">Reçus fiscaux</b-nav-item>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto" v-if="user">
          <b-nav-text class="font-weight-bold mr-3">
            {{ user.name }}
          </b-nav-text>

          <b-nav-item
            @click="logout"
            href="#"
            v-b-tooltip.hover
            title="Se déconnecter"
          >
            <font-awesome-icon class="iconRightSpace" icon="sign-out-alt" />
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <keep-alive include="projet">
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
import AuthService from "@/service/authService";

export default {
  data() {
    return {
      user: null,
    };
  },
  mounted: async function () {
    this.user = await AuthService.getUser();
  },
  methods: {
    logout() {
      AuthService.logout();
    },
  },
};
</script>
